<template>
  <div class="fadeIn fadeOut">
    <b-checkbox v-if="disk_list && disk_list.length > 0"  v-model="hide_docker_overlay">Docker Overlay Hide</b-checkbox>
    <hr v-if="disk_list && disk_list.length > 0">
    <div v-if="hide_docker_overlay == false || (hide_docker_overlay && (d.mountpoint.indexOf('docker/overlay') < 0 && d.mountpoint.indexOf('docker/containers') < 0 && d.mountpoint.indexOf('docker/volumes') < 0))" v-for="(d, index) in disk_list" v-bind:key="index" class="animated fadeIn fadeOut">
      <p :style="`display:inline-block; width:${folder_max_len}%; margin:0px;`">
        {{`[${d.mountpoint}]`.padEnd(folder_max_len, ' ')}}
      </p>
      <p :style="`display:inline-block; width:${74 - folder_max_len}%; margin:0px;`">
        <b-progress :max="100" height="1rem">
          <b-progress-bar :value="Number(d.percent.replace('%', ''))">
            <span>{{ d.percent }}</span>
          </b-progress-bar>
        </b-progress>
      </p>
      <p style="display:inline-block; width:20%; margin:0 0 0 10px;">
        {{d.used}} / {{d.total}}
      </p>
    </div>
    <hr v-show="disk_list && disk_list.length > 0">
  </div>
</template>
<style>
  .pulse {
  cursor: pointer;
  box-shadow: 0 0 0 rgba(204,169,44, 0.4);
  animation: pulse 2s infinite;
}
.pulse:hover {
  animation: none;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
    box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
      box-shadow: 0 0 0 10px rgba(204,169,44, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
      box-shadow: 0 0 0 0 rgba(204,169,44, 0);
  }
}
</style>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
